<template>
  <div v-gxxt-loading="loading">
    <div>
      <no-chapter-list
        v-if="!lessonInfo.hasChapter"
        :lessonInfo="lessonInfo"
        :goodsType="query.goodsType"
        :goodsId="query.goodsId"
        :resourceId="query.resourceId"
        :query="query"
      ></no-chapter-list>
      <chapter-list
        v-else
        :lessonInfo="lessonInfo"
        @toggle="toggle"
        :goodsType="query.goodsType"
        :goodsId="query.goodsId"
        :resourceId="query.resourceId"
        :query="query"
      ></chapter-list>
    </div>
    <div
      class="tc box"
      v-if="!loading && !lessonInfo.readPermission && lessonInfo.publishedCount == 0"
    >
      <div class="c-img"></div>
      <div class="c-text">购买后查看完整目录内容～</div>
    </div>
    <gxxt-no-data
      v-if="!loading && !!lessonInfo.readPermission && lessonInfo.publishedCount == 0"
      text="正在准备内容～"
    ></gxxt-no-data>
  </div>
</template>

<script>
import chapterList from './chapter-list.vue'
import noChapterList from './no-chapter-list.vue'
import { GxxtNoData } from '@/components'
import { jumpToLogin } from '@/utils/common'

export default {
  props: {
    query: Object,
    default: () => {
      return {}
    },
  },
  watch: {
    query: {
      deep: true,
      immediate: true,
      handler(v1, v2) {
        v2 = v2 ? v2 : {}
        if (v1 && v1.resourceId != v2.resourceId) {
          this.init()
        }
      },
    },
  },
  data() {
    return {
      loading: false,
      lessonInfo: {
        articles: [],
        chapters: [],
        hasChapter: false,
        publishedCount: 0,
        readPermission: false,
      },
    }
  },
  methods: {
    init() {
      if (this.query.goodsType == this.constants.goodsType.training) {
        this.getTrainCampLessonInfo()
      }
      if (this.query.goodsType == this.constants.goodsType.course) {
        this.getCourseLessonInfo()
      }
    },
    toggle(index) {
      this.lessonInfo.chapters[index].show =
        !this.lessonInfo.chapters[index].show
    },
    // 获取课程目录
    async getTrainCampLessonInfo() {
      this.loading = true
      let res = await this.api.course.getTrainCampLessonInfo(
        this.query.resourceId
      )
      if (res && res.code == 200) {
        if (
          Object.prototype.toString.call(res.data.articles) != '[object Array]'
        ) {
          res.data.articles = []
        }
        if (
          Object.prototype.toString.call(res.data.chapters) != '[object Array]'
        ) {
          res.data.chapters = []
        }
        res.data.chapters.forEach((it) => {
          it.show = true
        })
        this.lessonInfo = res.data
      } else if(res.code == 500 ){
        jumpToLogin();
      }
      this.loading = false
    },
    async getCourseLessonInfo() {
      this.loading = true
      let res = await this.api.course.getCourseLessonInfo(this.query.resourceId)
      if (res && res.code == 200) {
        if (
          Object.prototype.toString.call(res.data.articles) != '[object Array]'
        ) {
          res.data.articles = []
        }
        if (
          Object.prototype.toString.call(res.data.chapters) != '[object Array]'
        ) {
          res.data.chapters = []
        }
        res.data.chapters.forEach((it) => {
          it.show = true
        })
        this.lessonInfo = res.data
      }
      this.loading = false
    },
  },
  components: {
    chapterList,
    noChapterList,
    GxxtNoData,
  },
}
</script>

<style lang="less" scoped>
.box {
  margin-top: 200px;
}
.c-img {
  width: 288px;
  height: 264px;
  background-image: url('~@/assets/images/no-auth.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
}
.c-text {
  font-size: 24px;
  font-weight: 500;
  color: #aaaaaa;
  line-height: 24px;
  text-align: center;
  padding-top: 90px;
}
</style>